
      import Keyboard from './keyboard.vue'
      import type { App, Plugin } from 'vue'

      export const KeyboardPlugin: Plugin = {
        install(app: App) {
          app.component('Keyboard', Keyboard)
        },
      }
      export { Keyboard }
      